import { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { RegistrationContext } from '../../context/registration';

import {
    fetchCampaignPhotoPresignedUrl,
    uploadFile,
    saveCampaignPhoto,
} from '../../services/campaign';
import { fetchCampaignContext } from '~/services/registration';
import { campaignVideoUrl } from '../../services/start-campaign';
import { renderIcon } from '~/shared/components/icons';
import Dropzone from 'react-dropzone';

import { ProgressBar } from './ProgressBar';
import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Form,
    FormGroup,
    Input,
    Label,
    FormText,
    FormFeedback,
} from 'reactstrap';

import { Loading } from '../../shared/components/Loading';

const urlRegex =
    /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/;
export const Photo = ({}: any) => {
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [editCampaignPhoto, setEditCampaignPhoto] = useState(false);
    const [filename, setFilename] = useState();
    const [videoUrl, setVideoUrl] = useState('');
    const [invalidUrl, setInvalidUrl] = useState(false);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (campaignRequest) {
            setLoading(false);
        } else {
            getCampaign();
        }
    }, [campaignRequest]);

    useEffect(() => {
        if (videoUrl) {
            const valid = urlRegex.test(videoUrl);
            console.log('valid: ', valid);
            setInvalidUrl(!valid);
        }
    }, [videoUrl]);

    const getCampaign = async () => {
        const resp = await fetchCampaignContext();
        console.log('resp: ', resp);

        registrationDispatch({
            type: 'set_registration',
            payload: resp,
        });
    };

    const handleNext = async () => {
        try {
            setSaving(true);
            if (videoUrl) {
                const resp = await campaignVideoUrl({ video_url: videoUrl });
            }
            history.push('/start-campaign/share');
        } catch (e) {
            setSaving(false);
            console.log('e: ', e);
        }
    };

    if (loading) {
        return <Loading />;
    }

    const getFilename = (fullPath) => {
        if (!fullPath) {
            return '';
        }
        return fullPath.replace(/^.*[\\\/]/, '');
    };

    const ImgDropzone = () => {
        const handleDrop = (files) => {
            files.forEach(async (file) => {
                const { fields, url } = await fetchCampaignPhotoPresignedUrl(
                    file.name
                );
                setFilename(file.name);
                const resp = await uploadFile(fields, url, file);
                const { key } = fields;
                const payload = {
                    image: key,
                };
                const saveResp = await saveCampaignPhoto(payload);
                console.log('saveResp: ', saveResp);
                // campaignDispatch({
                //   type: 'set_campaign_photo',
                //   payload: saveResp,
                // });
                // setEditCampaignPhoto(false);
            });
        };
        return (
            <Dropzone
                onDrop={handleDrop}
                accept={{ 'image/*': ['.jpeg', '.jpg', '.png'] }}
                multiple={false}
            >
                {({ getRootProps, getInputProps }) => (
                    <Card className='my-3' style={{ border: '2px dashed' }}>
                        <CardBody>
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <p>
                                    Drag 'n' drop some files here, or click to
                                    select files
                                </p>
                            </div>
                        </CardBody>
                    </Card>
                )}
            </Dropzone>
        );
    };

    return (
        <Container>
            <ProgressBar selectedStep='goal' />
            <Row className='justify-content-center py-5'>
                <Col md='8'>
                    <div className='text-center'>
                        <h3>Let’s add a photo or video to your campaign</h3>
                    </div>

                    <Card
                        className='box-shadow my-5'
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <CardBody className='p-5'>
                            <Row className='justify-content-between'>
                                <Col md='6'>
                                    <Form>
                                        <h4>
                                            Add an image or video to get some
                                            extra attention
                                        </h4>
                                        <Row className='g-3 mb-3'>
                                            <Col xs='7'>
                                                <Input
                                                    readOnly={true}
                                                    value={filename || ''}
                                                />
                                            </Col>
                                            <Col>
                                                <Button
                                                    color='outline-dark'
                                                    onClick={() =>
                                                        setEditCampaignPhoto(
                                                            true
                                                        )
                                                    }
                                                >
                                                    <span className='me-2'>
                                                        {renderIcon('upload')}
                                                    </span>
                                                    Upload
                                                </Button>
                                            </Col>
                                        </Row>
                                        {editCampaignPhoto && <ImgDropzone />}
                                        <FormGroup>
                                            <Label>Campaign Video</Label>
                                            <Input
                                                id='video_url'
                                                name='video_url'
                                                onChange={(e) =>
                                                    setVideoUrl(e.target.value)
                                                }
                                            />
                                            <FormText>
                                                Enter Youtube or Vimeo URL
                                            </FormText>
                                            {invalidUrl && (
                                                <FormFeedback
                                                    style={{
                                                        display: 'inherit',
                                                    }}
                                                >
                                                    Invalid URL
                                                </FormFeedback>
                                            )}
                                        </FormGroup>
                                        <div className='text-center'>
                                            <Button
                                                color='link'
                                                onClick={() =>
                                                    history.push('/dashboard')
                                                }
                                                disabled={saving}
                                            >
                                                Go to Dashboard
                                            </Button>
                                            <Button
                                                color='primary'
                                                onClick={handleNext}
                                                disabled={saving || invalidUrl}
                                            >
                                                {saving
                                                    ? `Saving...`
                                                    : `Publish Campaign`}
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                                <Col md='4'>
                                    <Card className='bg-lightblue'>
                                        <CardBody>
                                            <h3>Successful Campaign Tips</h3>A
                                            enim facilisis amet tincidunt
                                            lobortis. Justo lectus euismod quam
                                            dictum eu et diam in interdum. Metus
                                            nam vel gravida quis. Aenean
                                            interdum fermentum ultricies
                                            habitant diam tortor vitae
                                            sollicitudin faucibus. Aliquam morbi
                                            leo a nec montes. Nunc lacus justo
                                            velit sed turpis convallis fringilla
                                            sagittis.
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
